import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import BranchSelector from '@/components/BranchSelector';
import { settingsApi } from '@/lib/store';

export default function AppLayout() {
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(() => settingsApi.get());

  useEffect(() => {
    const refresh = () => setS(settingsApi.get());
    window.addEventListener('kk_settings_changed', refresh);
    return () => window.removeEventListener('kk_settings_changed', refresh);
  }, []);

  return (
    <div className="min-h-screen flex bg-background">
      {/* Desktop sidebar */}
      <div className="hidden lg:block sticky top-0 h-screen">
        <Sidebar />
      </div>

      {/* Mobile sidebar */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-40" onClick={() => setOpen(false)}>
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-y-0 left-0 z-50" onClick={(e) => e.stopPropagation()}>
            <Sidebar onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        {/* Top bar (all viewports) */}
        <div className="sticky top-0 z-30 flex items-center justify-between px-4 h-14 border-b border-border bg-card/90 backdrop-blur-sm">
          <div className="flex items-center gap-2">
            <button
              onClick={() => setOpen(true)}
              data-testid="btn-open-sidebar"
              className="lg:hidden h-9 w-9 grid place-items-center rounded-md hover:bg-accent"
            >
              <Menu className="h-5 w-5" />
            </button>
            <div className="lg:hidden font-display font-bold tracking-tight">{s.shop_name}</div>
          </div>
          <div className="flex items-center gap-2">
            <BranchSelector />
          </div>
        </div>

        <main className="flex-1 p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
